import React from "react";
import {  MDBRow, MDBCol, MDBCard, MDBCardBody, MDBMask, MDBIcon, MDBView, MDBBtn } from "mdbreact";

const DPC = () => {
  return (
<React.Fragment>


        <h2 className="h1-responsive font-weight-bold text-center my-5">
        PRIVACY CONSENT FORM
        </h2>
        <p className="text-left">
       SIMS (Sales Inventory Mangement System) is a web-based information management system that allows the project owner to manage its sales and inventory.
        </p>
       

        <p className="text-left">
        <b>A.	AUTHORIZATION TO VERIFY YOUR IDENTITY.</b> &nbsp;&nbsp;Accessing and using SIMS is purely at your option. Should you choose to register and use this platform, we need your consent to verify and validate your identity. This is to protect you from identity fraud and other risks to your privacy and security.
        </p>
       


    
       
        <p className="text-left ml-3">
       
        <b>BY LOGGING IN, </b>you explicitly make the following representations and warranties:<br/><br/>
        (1)	That you expressly consent to and authorize us to directly validate your identity; <br/><br/>
        (2)	That you have fully read and understood the terms of this Consent Form including the scope of personal data processing involved in the platform and that you freely and voluntarily express your consent and conformity thereto; and,  <br/><br/>
        (3)	That you are who you represent to be on the platform and that you retain full and sole responsibility over the truthfulness and accuracy of the personal data you provide about yourself.<br/><br/>
        </p>
        </React.Fragment>
   
  );
}

export default DPC;